import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, DatePicker, Divider, Form, Input, Row, Space } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { GrupoPlanoContaFinanceiroModel } from "../../../../models/grupoPlanoContaFinanceiro/grupoPlanoContaFinanceiroModel";
import { setModalCadastrarGrupoPlanoContaFinanceiro } from "../../../../redux/slices/grupoPlanoContaFinanceiro/grupoPlanoContaFinanceiroSlice";
import { atualizarGrupoPlanoContaFinanceiro, buscarGrupoPlanoContaFinanceiro, cadastrarGrupoPlanoContaFinanceiro } from "../../../../services/grupoPlanoContaFinanceiroService";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";

const CadastroGrupoPlanoContaFinanceiro = () => {
  //estados globais
  const grupoPlanoContaFinanceiroState = useAppSelector((state) => state.grupoPlanoContaFinanceiro);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<GrupoPlanoContaFinanceiroModel>();

  const editar = Object.values(grupoPlanoContaFinanceiroState.entity).length !== 0;

  useEffect(() => {
    if (editar) {
      form.setFieldsValue({
        ...grupoPlanoContaFinanceiroState.entity,
        dataCriacao: grupoPlanoContaFinanceiroState.entity.dataCriacao !== null ? dayjs(new Date(grupoPlanoContaFinanceiroState.entity.dataCriacao)) : "",
      });
    }
  }, [grupoPlanoContaFinanceiroState.entity]);

  const submit = (values: GrupoPlanoContaFinanceiroModel) => {
    if (editar) {
      dispatch(atualizarGrupoPlanoContaFinanceiro({ value: { ...values, id: grupoPlanoContaFinanceiroState.entity.id }, busca: grupoPlanoContaFinanceiroState.busca }));
    } else {
      dispatch(cadastrarGrupoPlanoContaFinanceiro({ value: values, busca: grupoPlanoContaFinanceiroState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarGrupoPlanoContaFinanceiro(false));
  };

  return (
    <Form form={form} onFinish={submit} layout="vertical">
      <Row gutter={12} justify="space-around">
        <Col>
          <Form.Item
            label="Denominacao"
            name="denominacao"
            rules={[
              {
                required: true,
                message: "Digite a denominação",
              },
            ]}
          >
            <Input type="text" placeholder="Digite a denominação" maxLength={100} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item
            label="Abreviacao"
            name="abreviacao"
            rules={[
              {
                required: true,
                message: "Digite a abreviação",
              },
            ]}
          >
            <Input type="text" placeholder="Digite a abreviação" maxLength={100} />
          </Form.Item>
        </Col>

        <Col>
          <Form.Item label="Data de criação" name="dataCriacao">
            <DatePicker format={"DD/MM/YYYY"} disabled defaultValue={dayjs()} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item label="Ativo" name="ativo" valuePropName="checked" initialValue={true}>
            <Checkbox name="ativo">Ativo</Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <div className="modalFooter">
        <Space size="middle">
          <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
            FECHAR
          </Button>
          <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
            SALVAR
          </Button>
        </Space>
      </div>
    </Form>
  );
};

export default CadastroGrupoPlanoContaFinanceiro;
